export const BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const ENDPOINTS = {
  MaintenanceDataCount: `${BASE_URL}/dashboard/maintenance-date-count`,
  UpComingMaintenance: `${BASE_URL}/dashboard/top-upcoming-maintenance`,
  OverDueMaintenance: `${BASE_URL}/dashboard/top-overdue-maintenance`,
  ServicesInfo: `${BASE_URL}/dashboard/services-info`,
  WorkOrderInfo: `${BASE_URL}/dashboard/work-order-info`,
  TyreInstalledData: `${BASE_URL}/dashboard/latest-installed-tyres`,
  TopVehicleCost: `${BASE_URL}/dashboard/top-vehicle-by-cost`,
  MaintenanceCostOverview: `${BASE_URL}/dashboard/maintenance-cost-overview`,
  MaintenanceCategory: `${BASE_URL}/maintenance/maintenance-category-dropdown`,
  workDoneBy: `${BASE_URL}/dashboard/work-done-by`,
  LateEntries: `${BASE_URL}/dashboard/paginated-late-entries`,
  CompletePm: `${BASE_URL}/dashboard/complete-pm-paginated`,
  VehicleInfoApi: `${BASE_URL}/dashboard/vehicle-info`,
  TyreInfoApi: `${BASE_URL}/dashboard/tyres-info`,
};
